var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24c-6.075 0-11-4.925-11-11S17.925 2 24 2s11 4.925 11 11-4.925 11-11 11zm0-4a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm20.817 14.164c.35.762.596 1.86.81 3.318a47.659 47.659 0 0 1 .345 3.077l.023.299L46 41a5 5 0 0 1-4.994 5H6.994A5 5 0 0 1 2 41l.005-.142.023-.299a53.767 53.767 0 0 1 .345-3.077c.214-1.458.46-2.556.81-3.318C4.72 30.827 16.035 26 24 26s19.28 4.827 20.817 8.164zm-3.837 1.524c-.28-.245-.68-.539-1.175-.857-1.108-.713-2.572-1.475-4.189-2.165C31.74 31.012 27.583 30 24 30s-7.739 1.012-11.616 2.666c-1.617.69-3.081 1.452-4.189 2.165-.494.318-.895.612-1.175.857-.104.092-.184.17-.237.229-.135.354-.305 1.141-.452 2.146-.099.67-.183 1.394-.253 2.12-.036.374-.062.676-.077.871a1 1 0 0 0 .993.946h34.012a1 1 0 0 0 .993-.946c-.015-.195-.04-.497-.077-.87a43.781 43.781 0 0 0-.253-2.121c-.147-1.005-.317-1.792-.452-2.146a2.842 2.842 0 0 0-.237-.229z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.32241901e29cdc69a9c983bb35442c85.svg";
export { ForwardRef as ReactComponent };